// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"sn-z","imageAndVideoCount":"tn-z","imageAndVideoContainer":"un-z","viewAllReviews":"vn-z"};